module.exports = __webpack_public_path__ + "static/media/finished-ipad-img3.06cf215b.png";